import zodJSON from 'zod-i18n-map/locales/de/zod.json'
import countries from 'i18n-iso-countries'
import countriesJSON from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(countriesJSON)

export const de = {
    zod: {
        ...zodJSON,
        custom: {
            required: 'Muss ausgefüllt werden',
            invalidCountry: 'Ungültiges Land',
            invalidZip: 'Ungültige Postleitzahl',
            invalidState: 'Ungültiges Bundesland',
            invalidTime: 'Ungültige Zeit',
            invalidDateOnly: 'Ungültiges Datum (UTC-Stunden müssen null sein)',
            invalidTimeRange: 'Ungültiger Zeitbereich',
            invalidDateRange: 'Ungültiger Datumsbereich',
            invalidDateTimeRange: 'Ungültiger Datums- und Zeitbereich',
            invalidRRule: 'Ungültige Wiederholungsregel (RRule)',
            rruleMustEnd: 'Die angegebene Wiederholungsregel muss ein Ende haben',
            invalidTaxID: 'Ungültige Steuernummer',
            invalidVATID: 'Ungültige USt-IdNr.',
            invalidCreditorIdentifier: 'Ungültige Gläubiger-Identifikationsnummer',
            invalidBIC: 'Ungültige BIC',
            invalidIBAN: 'Ungültige IBAN',
            invalidSepaMandateId: 'Ungültige SEPA-Mandats-ID',
            invalidObjectId: 'Ungültige Objekt-ID',
            invalidPhone: 'Ungültige Telefonnummer',
            invalidEmail: 'Ungültige E-Mail-Adresse',
            invalidOption: 'Ungültige Option',
            invalidReference: 'Ungültige oder nicht vorhandene Referenz',
            resourceRequired: 'Eine Datei muss ausgewählt werden',
            fromBeforeTo: 'Das Startdatum darf nicht nach dem Enddatum liegen',
            duplicate: 'Doppelter Wert',
        },
    },
    translation: {
        language: {
            en: 'Englisch',
            de: 'Deutsch',
        },
        timeUnit: {
            millisecond: 'Millisekunde',
            milliseconds: 'Millisekunden',
            second: 'Sekunde',
            seconds: 'Sekunden',
            minute: 'Minute',
            minutes: 'Minuten',
            hour: 'Stunde',
            hours: 'Stunden',
            day: 'Tag',
            days: 'Tage',
            week: 'Woche',
            weeks: 'Wochen',
            month: 'Monat',
            months: 'Monate',
            quarter: 'Quartal',
            quarters: 'Quartale',
            year: 'Jahr',
            years: 'Jahre',
        },
        rruleIds: {
            repeats: 'Wiederholt sich',
            every: 'jede(n)',
            until: 'bis',
            for: 'für',
            in: 'in',
            the: 'der',
            and: 'und',
            or: 'oder',
            on: 'am',
            'on the': 'an dem',
            last: 'letzte(r)',
            st: 'ten',
            nd: 'ten',
            rd: 'ten',
            th: 'ten',
            time: 'mal',
            times: 'male',
            hour: 'Stunde',
            hours: 'Stunden',
            minute: 'Minute',
            minutes: 'Minuten',
            weekday: 'Wochentag',
            weekdays: 'Wochentage',
            day: 'Tag',
            days: 'Tage',
            week: 'Woche',
            weeks: 'Wochen',
            month: 'Monat',
            months: 'Monate',
            year: 'Jahr',
            years: 'Jahre',
        },
        entities: {
            common: {
                recipientType: {
                    business: 'Unternehmen',
                    person: 'Person',
                },
            },
        },
        form: {
            functions: {
                age: {
                    expression: 'Alter',
                },
                date: {
                    expression: 'Datum',
                },
                today: {
                    expression: 'Heute',
                },
                number: {
                    expression: 'Zahl',
                },
                formatDate: {
                    expression: 'Datums-Format',
                },
            },
            validators: {
                phone: {
                    name: 'Telefonnummer',
                    error: 'Ungültige Telefonnummer',
                },
                mobile_phone: {
                    name: 'Mobilfunknummer',
                    error: 'Ungültige Mobilfunknummer',
                },
                url: {
                    name: 'URL / Link',
                    error: 'Ungültige URL',
                },
                iban: {
                    name: 'IBAN',
                    error: 'Ungültige IBAN',
                },
                bic: {
                    name: 'BIC',
                    error: 'Ungültige BIC',
                },
                hex_color: {
                    name: 'Farbwert',
                    error: 'Ungültiger Farbwert',
                },
                regex: {
                    name: 'Regex',
                    error: 'Ungültiger Regex-Abgleich',
                },
                email: {
                    name: 'E-Mail',
                    error: 'Ungültige E-Mail',
                },
                number: {
                    name: 'Zahl',
                    error: 'Ungültige Zahl',
                },
                text: {
                    name: 'Text',
                    error: 'Ungültiger Text',
                },
            },
            properties: {
                text: {
                    format: {
                        displayName: 'Format',
                        text: 'Einfacher Text',
                        email: 'E-Mail',
                        url: 'URL / Link',
                        phone: 'Telefonnummer',
                        mobile: 'Mobilfunknummer',
                        iban: 'IBAN',
                        bic: 'BIC',
                        number: 'Zahl',
                        range: 'Bereich',
                        date: 'Datum',
                        time: 'Zeit',
                        dateTime: 'Datum und Zeit',
                        month: 'Monat',
                        week: 'Woche',
                        color: 'Farbe',
                        regex: 'Benutzerdefinierte Maske',
                    },
                },
                file: {
                    acceptedTypesWrapper: {
                        displayName: 'Akzeptierte Dateien',
                        image: 'Bilder',
                        video: 'Videos',
                        pdf: 'PDF-Dokumente',
                        all: 'Alle Dateien',
                    },
                },
            },
            survey: {},
        },
        tenant: {
            permissions: {
                title: 'Berechtigungen',
                scopes: {
                    tenant: 'Mandant',
                    user: 'Administrator',
                    application: 'Anwendung',
                    identity: 'Identitäten',
                },
                scopePermissions: {
                    read: 'Lesen',
                    insert: 'Einfügen',
                    edit: 'Bearbeiten',
                    remove: 'Löschen',
                },
            },
            restrictions: {
                title: 'Einschränkungen',
                scopes: {
                    application: 'Anwendung',
                },
            },
        },
        utils: {
            misc: {
                formatSequenceNumber: {
                    duplicateCounterPlaceholder:
                        'Es wurden weitere Zählerplatzhalter an Position {{position}} gefunden, es ist jedoch nur einer erlaubt',
                    invalidCounterPlaceholder:
                        'Ungültiger Zählerplatzhalter an Position {{position}}, erwartet Ziffer 1-9',
                    missingCounterPlaceholder: 'Fehlender Platzhalter für den Zähler',
                },
            },
            email: {
                defaultEmail: {
                    name: 'Inhalt',
                    description: 'Beschreibung',
                },
            },
        },
        misc: {
            unknown: 'Unbekannt',
            close: 'Schließen',
            fullYear: 'Ganzes Jahr',
            today: 'Heute',
            yesterday: 'Gestern',
            tomorrow: 'Morgen',
            untitled: 'Unbetitelt',
            and: 'und',
            or: 'oder',
            numberSeparatorWord: 'Komma',
            point: 'Punkt',
            pointShort: 'Pkt.',
            points: 'Punkte',
            pointsShort: 'Pkt.',
            freePrice: 'Keine Gebühr',
            copyOf: 'Kopie von {{name}}',
        },
    },
}
